export function assertUnreachable(name?: string): never {
  const errorString = `unreachable assertion failure${name ? `: ${name}` : `.`}`;
  throw new Error(errorString);
}
